<template>
  <v-btn
    flat
    class="ml-0 pa-0 boiler-button boiler-button-2 mr-2"
    v-if="controllerData"
    @click="$emit('imageNavigation')"
  >
    <div v-if="controllerData.frontdata" class="on-button-text">
      <!-- <p v-if="controllerData.frontdata[0].id === 'hoppercontent'" class="mb-0">
        {{ controllerData.frontdata[0].value | weightConversion }}
        {{ controllerData.frontdata[0].unit | translate }}
      </p> -->
      <p class="mb-0">
        {{ controllerData.frontdata[11].value }}
        {{ controllerData.frontdata[11].unit | translate }}
      </p>
      <p class="mb-0">
        <!-- Todo: Insert the calculated hopper content here -->
      </p>
    </div>
    <v-img
      v-if="controllerData.model === '0'"
      :src="require(`../assets/${this.selectHopperImage(0)}`)"
    ></v-img>
    <v-img
      v-if="controllerData.model === '1'"
      :src="require(`../assets/${this.selectHopperImage(1)}`)"
    ></v-img>
    <!-- <span
      class="hopper-minimum"
      v-if="
        controllerData.miscdata &&
          controllerData.miscdata['vacuum.output_auger'] != undefined &&
          controllerData.miscdata['vacuum.output_auger'] !== '0'
      "
    >
      {{ controllerData.miscdata["vacuum.max_distance"] }}
      {{ "LNG_PCT" | translate }}
    </span> -->
  </v-btn>
</template>

<script>
export default {
  props: {
    controllerData: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    isBetween(value, lower, upper) {
      return lower <= Math.round(value) && Math.round(value) <= upper;
    },
    selectHopperImage(model) {
      const distance = this.controllerData.miscdata.hopperdistance;
      const image = this.controllerData.frontdata[12].value;
      let basicPath = "";
      if(model === 0){
        basicPath = "bundle0/hopper/";
      } else if(model === 1){
        basicPath = "bundle1/hopper/";
      }

      if (
        distance === undefined ||
        distance === "" ||
        distance === null ||
        distance > 400
      ) {
        return `${basicPath}${model ? "BS-Silo-front.png" : "RTB-Silo-front.png"}`;
      }

      if (image === 0) {
        return `${basicPath}${model ? "bs_silo_0.png" : "rtb_silo_0.png"}`;
      } else if (image === 1) {
        return `${basicPath}${model ? "bs_silo_1.png" : "rtb_silo_1.png"}`;
      } else if (image === 2) {
        return `${basicPath}${model ? "bs_silo_2.png" : "rtb_silo_2.png"}`;
      } else if (image === 3) {
        return `${basicPath}${model ? "bs_silo_3.png" : "rtb_silo_3.png"}`;
      } else if (image === 4) {
        return `${basicPath}${model ? "bs_silo_4.png" : "rtb_silo_4.png"}`;
      } else if (image === 5) {
        return `${basicPath}${model ? "bs_silo_5.png" : "rtb_silo_5.png"}`;
      }

      return `${basicPath}${model ? "BS-Silo-front.png" : "RTB-Silo-front.png"}`;
    }
  }
};
</script>
<style>
.hopper-minimum {
  display: block;
  color: #fff;
  position: absolute;
  bottom: 5%;
  width: 100%;
  border-top: 1px dashed #a60700;
  z-index: 999;
  padding-top: 7px;
}
</style>
